import React, {Component} from 'react';
import Progressbars from './Progressbars';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free-solid';


class Skills extends Component {
    render() {
        return (
            <div id="skills-page">
                <h3 className="uk-text-uppercase uk-text-bold">Skills</h3>
                <div className="uk-animation-slide-top-small">
                    <div uk-grid="true">
                        <div className="uk-width-1-1 uk-width-1-2@l uk-width-1-2@m uk-width-1-2@xl uk-width-1-2@s">
                            <h4>Web Technologies</h4>
                            <div uk-grid="true">
                                <div className="uk-width-1-2 uk-width-1-3@xl uk-width-1-3@l uk-width-1-2@m uk-width-1-2@s">
                                    <ul>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> HTML/HTML5</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> CSS/CSS3</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> LESS/SASS</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> JavaScript</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> jQuery</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Ajax</li>
                                    </ul>
                                </div>
                                <div className="uk-width-1-2 uk-width-1-3@xl uk-width-1-3@l uk-width-1-2@m uk-width-1-2@s">
                                    <ul>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> JSON</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> PHP</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> AngularJS</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Angular2</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> ReactJS</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> NodeJS</li>
                                    </ul>
                                </div>
                                <div className="uk-width-1-1 uk-width-1-3@xl uk-width-1-3@l uk-width-1-1@m uk-width-1-2@s ">
                                    <ul>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Drupal</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Wordpress</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Laravel</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Yii</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Symfony</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Codeigniter</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-1-1 uk-width-1-2@l uk-width-1-2@m uk-width-1-2@xl uk-width-1-2@s">
                            <div className="uk-margin-small uk-position-relative">
                                <p className="uk-margin-remove-bottom">HTML/HTML5</p>
                                <Progressbars name="html" barType="line" progress="0.9"/>
                            </div>
                            <div className="uk-margin-small uk-position-relative">
                                <p className="uk-margin-remove-bottom">CSS/CSS3</p>
                                <Progressbars name="css" barType="line" progress="0.9"/>
                            </div>
                            <div className="uk-margin-small uk-position-relative">
                                <p className="uk-margin-remove-bottom">JavaScript</p>
                                <Progressbars name="javascript" barType="line" progress="0.8"/>
                            </div>
                            <div className="uk-margin-small uk-position-relative">
                                <p className="uk-margin-remove-bottom">jQuery</p>
                                <Progressbars name="jquery" barType="line" progress="0.85"/>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div uk-grid="true">
                        <div className="uk-width-1-4@xl uk-width-1-4@l uk-width-1-4@m uk-width-1-2@s uk-width-1-2">
                            <h4>Frontend Framework's</h4>
                            <ul>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Zurb Foundation</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Twitter Bootstrap</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> UIKit</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Pure CSS</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Semantic UI</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Skeleton CSS</li>
                            </ul>
                        </div>
                        <div className="uk-width-1-4@xl uk-width-1-4@l uk-width-1-4@m uk-width-1-2@s uk-width-1-2">
                            <h4>Development Tool's</h4>
                            <ul>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Eclipse IDE</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Netbeans IDE</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> intellij IDE</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Sublime Text</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Notepad++</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Visual Studio Code</li>
                            </ul>
                        </div>
                        <div className="uk-width-1-4@xl uk-width-1-4@l uk-width-1-4@m uk-width-1-2@s uk-width-1-2">
                            <h4>Web Server's</h4>
                            <ul>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> XAMPP</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> WAMP</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> LAMP</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Apache Tomcat</li>
                            </ul>
                        </div>
                        <div className="uk-width-1-4@xl uk-width-1-4@l uk-width-1-4@m uk-width-1-2@s uk-width-1-2">
                            <h4>Version Control's</h4>
                            <ul>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Git</li>
                                <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Tortoise SVN</li>
                            </ul>
                        </div>
                    </div>
                    <hr/>
                    <div uk-grid="true">
                        <div className="uk-width-1-2 uk-width-1-6@xl uk-width-1-6@l uk-width-1-6@m uk-width-1-3@s">
                            <div className="uk-margin-small uk-position-relative">
                                <Progressbars name="php" barType="circle" progress="0.8"/>
                                <p className="uk-text-center">PHP</p>
                            </div>
                        </div>
                        <div className="uk-width-1-2 uk-width-1-6@xl uk-width-1-6@l uk-width-1-6@m uk-width-1-3@s">
                            <div className="uk-margin-small uk-position-relative">
                                <Progressbars name="reactjs" barType="circle" progress="0.85"/>
                                <p className="uk-text-center">ReactJS</p>
                            </div>
                        </div>
                        <div className="uk-width-1-2 uk-width-1-6@xl uk-width-1-6@l uk-width-1-6@m uk-width-1-3@s">
                            <div className="uk-margin-small uk-position-relative">
                                <Progressbars name="angularjs" barType="circle" progress="0.7"/>
                                <p className="uk-text-center">AngularJS</p>
                            </div>
                        </div>
                        <div className="uk-width-1-2 uk-width-1-6@xl uk-width-1-6@l uk-width-1-6@m uk-width-1-3@s">
                            <div className="uk-margin-small uk-position-relative">
                                <Progressbars name="drupal" barType="circle" progress="0.85"/>
                                <p className="uk-text-center">Drupal</p>
                            </div>
                        </div>
                        <div className="uk-width-1-2 uk-width-1-6@xl uk-width-1-6@l uk-width-1-6@m uk-width-1-3@s">
                            <div className="uk-margin-small uk-position-relative">
                                <Progressbars name="bootstrap" barType="circle" progress="0.9"/>
                                <p className="uk-text-center">Bootstrap</p>
                            </div>
                        </div>
                        <div className="uk-width-1-2 uk-width-1-6@xl uk-width-1-6@l uk-width-1-6@m uk-width-1-3@s">
                            <div className="uk-margin-small uk-position-relative">
                                <Progressbars name="adobephotoshop" barType="circle" progress="0.9"/>
                                <p className="uk-text-center">Adobe Photoshop</p>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div uk-grid="true">
                        <div className="uk-width-1-1 uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s">
                            <div className="uk-margin-small uk-position-relative">
                                <p className="uk-margin-remove-bottom">NodeJS</p>
                                <Progressbars name="nodejs" barType="line" progress="0.9"/>
                            </div>
                            <div className="uk-margin-small uk-position-relative">
                                <p className="uk-margin-remove-bottom">Zurb Foundation</p>
                                <Progressbars name="zurbfoundation" barType="line" progress="0.9"/>
                            </div>
                            <div className="uk-margin-small uk-position-relative">
                                <p className="uk-margin-remove-bottom">Codeigniter</p>
                                <Progressbars name="codeigniter" barType="line" progress="0.8"/>
                            </div>
                            <div className="uk-margin-small uk-position-relative">
                                <p className="uk-margin-remove-bottom">Adobe Illustrator</p>
                                <Progressbars name="adobeillustrator" barType="line" progress="0.85"/>
                            </div>
                        </div>
                        <div className="uk-width-1-1 uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s">
                            <h4>Knowledge</h4>
                            <div uk-grid="true">
                                <div className="uk-width-1-2">
                                    <ul>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Adobe Photoshop</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Adobe Illustrator</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Adobe Flash</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Adobe Dreamweaver</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Sony Sound Forge</li>
                                    </ul>
                                </div>
                                <div className="uk-width-expand">
                                    <ul>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Unix/Linux</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Windows</li>
                                        <li><FontAwesomeIcon icon="arrow-right" className="fa-sm"/> Mac</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="uk-padding-small"></div>
                </div>
            </div>
        )
    }
}

export default Skills;


// WEBPACK FOOTER //
// src/components/Skills.js